import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { FG_3 } from 'components/upb_viewer_beta/css/betaTokens';

/**
 * InfluenceInfoTip — an info icon that reveals an explanatory tooltip on hover/focus.
 * Used to document what each dashboard column measures.
 */
function InfluenceInfoTip({ text, id }) {
  return (
    <OverlayTrigger
      placement="top"
      transition={false}
      overlay={props => (
        <Tooltip {...props} id={id}>
          {text}
        </Tooltip>
      )}
    >
      <span className={css(styles.wrap)} tabIndex={0} role="button" aria-label={text}>
        <FontAwesomeIcon icon={faInfoCircle} className={css(styles.icon)} />
      </span>
    </OverlayTrigger>
  );
}

const styles = StyleSheet.create({
  wrap: { marginLeft: 5, cursor: 'help', display: 'inline-flex', verticalAlign: 'middle' },
  icon: { color: FG_3, fontSize: 11 },
});

InfluenceInfoTip.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default InfluenceInfoTip;
